// =============================================================================
// cgu-pdf-download.ts — Déclenche le téléchargement navigateur d'octets PDF (helper isolé).
// =============================================================================
// Les octets viennent de l'API (GET .../versions/:id/pdf, no-store — preuve légale). On
// matérialise un Blob application/pdf, un object URL éphémère, un <a download> synthétique,
// puis on révoque l'URL. Isolé ici pour rester testable/mockable et hors composant.

/** Ouvre la boîte de téléchargement du navigateur pour des octets PDF. No-op hors DOM (SSR/tests). */
export function triggerPdfDownload(bytes: ArrayBuffer, filename: string): void {
  if (typeof document === 'undefined' || typeof URL.createObjectURL !== 'function') {
    return;
  }
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
